import React from "react";
import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

// ---------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  backgroundImage: `url("/assets/roadmap-bg.png")`,
  backgroundSize: "cover",
  marginTop: "88px",
}));

const InnerContainerStyle = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  position: "relative",
  zIndex: 3,
}));

const CoverImgStyle = styled("div")({
  top: 0,
  width: "100%",
  height: "110.5%",
  objectFit: "cover",
  position: "absolute",
  opacity: 0.6,
  backgroundColor: "#000",
  zIndex: 1,
});

const DateStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "80px",
  fontFamily: "Helvetica",
  fontWeight: 700,
  textAlign: "center",
}));

const ContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "15px",
  fontFamily: "Helvetica",
  fontWeight: 700,
  textAlign: "center",
  marginBottom: "10px",
}));

const DividerStyle = styled("div")(({ theme }) => ({
  backgroundColor: "#fff",
  width: "1px",
  height: "50px",
  margin: "15px auto",
}));

export default function RoadmapMobileContent() {
  return (
    <ContainerStyle>
      <InnerContainerStyle>
        <Stack>
          <DateStyle sx={{ mt: 3 }}>2022</DateStyle>
          <ContentStyle>
            10,000 MEMBERSHIP SOLD
            <br />
            5 R/HOOD EVENTS
            <br />
            GLOBAL COMMUNITY OF CREATIVES
          </ContentStyle>
        </Stack>

        <DividerStyle />

        <Stack>
          <DateStyle>2023</DateStyle>
          <ContentStyle>
            CULTURE MAKER DAO
            <br />
            FIRST R/HOOD PHYSICAL PRODUCTS
            <br />
            20 R/HOOD EVENTS
            <br />
            SURPRISE AIRDROP
          </ContentStyle>
        </Stack>

        <DividerStyle />

        <Stack>
          <DateStyle>2024</DateStyle>
          <ContentStyle>
            R/HOOD PHYSICAL SPACES
            <br />
            50 R/HOOD EVENTS
            <br />
            SURPRISE AIRDROP
            <br />
            METAVERSE
          </ContentStyle>
        </Stack>

        <DividerStyle />

        <Stack>
          <DateStyle>2025</DateStyle>
          <ContentStyle>
            COMMUNITY-OWNED BRANDS
            <br />
            R/HOOD ACCELERATOR PROGRAM
            <br />
            TV-SERIES: OUR HOOD
            <br />
            100 R/HOOD EVENTS
          </ContentStyle>
        </Stack>
      </InnerContainerStyle>

      <CoverImgStyle />
    </ContainerStyle>
  );
}
